!function(e, t, i) {
    function o(e, i, o) {
        var a, n = o, s = i, r = i;
        this.pause = function(e) {
            n -= e || 0,
            t.clearTimeout(a),
            s = r - n
        }
        ,
        this.resume = function() {
            t.clearTimeout(a),
            a = t.setTimeout(e, s)
        }
        ,
        this.resume()
    }
    function a() {
        var e = !1;
        return function(t) {
            (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4))) && (e = !0)
        }
        (navigator.userAgent || navigator.vendor || t.opera),
        e
    }
    function n() {
        d = t[l](function() {
            p.each(function() {
                var t = e(this)
                  , i = t.width()
                  , o = t.height()
                  , a = e.data(this, f);
                (i !== a.w || o !== a.h) && t.trigger(m, [a.w = i, a.h = o])
            }
            ),
            n()
        }
        , c[h])
    }
    var s = function(t, i) {
        var o = this;
        o.options = i,
        o.sliderContent = t,
        o.sliderInner = o.sliderContent.html(),
        o.sliderContent.html("<div class='iviewSlider'>" + o.sliderInner + "</div>"),
        o.slider = e(".iviewSlider", o.sliderContent),
        o.slider.css("position", "relative"),
        "undefined" != typeof o.options.sliderWidth && o.slider.css("width", o.options.sliderWidth),
        "undefined" != typeof o.options.sliderHeight && o.slider.css("height", o.options.sliderHeight);
        var a = o.sliderContent.width()
          , n = o.sliderContent.height();
        a < o.slider.width() && (a = o.slider.width()),
        n < o.slider.height() && (n = o.slider.height()),
        o.defs = {
            slide: 0,
            total: 0,
            image: "",
            images: [],
            width: a,
            height: n,
            timer: i.timer.toLowerCase(),
            lock: !1,
            paused: i.autoAdvance ? !1 : !0,
            time: i.pauseTime,
            easing: i.easing
        },
        o.disableSelection(o.slider[0]),
        o.slides = o.slider.children(),
        o.slides.each(function() {
            var t = e(this);
            if (o.defs.images.push(t.data("iviewimage")),
            t.data("iviewthumbnail") && o.defs.images.push(t.data("iviewthumbnail")),
            t.css("display", "none"),
            "video" == t.data("iviewtype")) {
                var a = t.children().eq(0)
                  , n = e('<div class="iview-video-show"><div class="iview-video-container"><a class="iview-video-close" title="' + i.closeLabel + '">&#735;</a></div></div>');
                t.append(n),
                a.appendTo(e("div.iview-video-container", n)),
                n.css({
                    width: o.defs.width,
                    height: o.defs.height,
                    top: "-" + o.defs.height + "px"
                }).hide(),
                t.addClass("iview-video").css({
                    cursor: "pointer"
                })
            }
            o.defs.total++
        }
        ).css({
            width: o.defs.width,
            height: o.defs.height
        }),
        o.sliderContent.append('<div id="iview-preloader" class="tp-loader"><div></div></div>');
        var s = e("#iview-preloader", o.sliderContent)
          , d = e("div", s);
        s.css({
            top: o.defs.height / 2 - s.height() / 2 + "px",
            left: o.defs.width / 2 - s.width() / 2 + "px"
        }),
        o.options.prevId && e(o.options.prevId).length > 0 && e(o.options.prevId).css({
            display: "none",
            position: "absolute",
            "margin-top": o.options.prevMarginTop,
            left: o.options.prevLeft,
            top: o.defs.height / 2 - e(o.options.prevId).height() / 2 + "px"
        }),
        o.options.nextId && e(o.options.nextId).length > 0 && e(o.options.nextId).css({
            display: "none",
            position: "absolute",
            "margin-top": o.options.nextMarginTop,
            right: o.options.nextRight,
            top: o.defs.height / 2 - e(o.options.nextId).height() / 2 + "px"
        }),
        o.sliderContent.append('<div id="iview-timer" class="ves-bannertimer"><div></div></div>'),
        o.iviewTimer = e("#iview-timer", o.sliderContent),
        o.iviewTimer.hide(),
        e(".iview-caption", o.slider).each(function() {
            var t = e(this);
            t.html('<div class="caption-contain">' + t.html() + "</div>")
        }
        ),
        i.startSlide = i.randomStart ? Math.floor(Math.random() * o.defs.total) : i.startSlide,
        i.startSlide = i.startSlide > 0 && i.startSlide >= o.defs.total ? o.defs.total - 1 : i.startSlide,
        o.defs.slide = i.startSlide,
        o.defs.image = o.slides.eq(o.defs.slide),
        o.defs.time = o.defs.image.data("iviewpausetime") ? o.defs.image.data("iviewpausetime") : i.pauseTime,
        o.defs.easing = o.defs.image.data("ivieweasing") ? o.defs.image.data("ivieweasing") : i.easing,
        o.pieDegree = 0;
        var p = i.timerPadding
          , c = i.timerDiameter
          , l = i.timerStroke;
        if (o.defs.total > 1 && "bar" != o.defs.timer) {
            l = "360bar" == o.defs.timer ? i.timerStroke : 0;
            var m = c + 2 * p + 2 * l
              , f = m
              , h = Raphael(o.iviewTimer[0], m, f);
            o.R = c / 2;
            var u = {
                stroke: i.timerBg,
                "stroke-width": l + 2 * p
            }
              , g = {
                stroke: i.timerColor,
                "stroke-width": l,
                "stroke-linecap": "round"
            }
              , v = {
                fill: i.timerColor,
                stroke: "none",
                "stroke-width": 0
            }
              , w = {
                fill: i.timerBg,
                stroke: "none",
                "stroke-width": 0
            };
            h.customAttributes.arc = function(e, t) {
                var i, o = 360, a = 360 / o * e, n = (90 - a) * Math.PI / 180, s = c / 2 + p + l, r = c / 2 + p + l, d = s + t * Math.cos(n), m = r - t * Math.sin(n);
                return i = o == e ? [["M", s, r - t], ["A", t, t, 0, 1, 1, 299.99, r - t]] : [["M", s, r - t], ["A", t, t, 0, +(a > 180), 1, d, m]],
                {
                    path: i
                }
            }
            ,
            h.customAttributes.segment = function(e, t) {
                var i = -90;
                t -= 1,
                e = i + e;
                var o = e - i > 180
                  , a = c / 2 + p
                  , n = c / 2 + p;
                return i = i % 360 * Math.PI / 180,
                e = e % 360 * Math.PI / 180,
                {
                    path: [["M", a, n], ["l", t * Math.cos(i), t * Math.sin(i)], ["A", t, t, 0, +o, 1, a + t * Math.cos(e), n + t * Math.sin(e)], ["z"]]
                }
            }
            ,
            o.defs.total > 1 && "pie" == o.defs.timer && h.circle(o.R + p, o.R + p, o.R + p - 1).attr(w),
            o.timerBgPath = h.path().attr(u),
            o.timerPath = h.path().attr(g),
            o.pieTimer = h.path().attr(v)
        }
        if (o.barTimer = e("div", o.iviewTimer),
        o.defs.total > 1 && "360bar" == o.defs.timer && o.timerBgPath.attr({
            arc: [359.9, o.R]
        }),
        "bar" == o.defs.timer ? (o.iviewTimer.css({
            opacity: i.timerOpacity,
            width: c,
            height: l,
            border: i.timerBarStroke + "px " + i.timerBarStrokeColor + " " + i.timerBarStrokeStyle,
            padding: p,
            background: i.timerBg
        }),
        o.barTimer.css({
            width: 0,
            height: l,
            background: i.timerColor,
            "float": "left"
        })) : o.iviewTimer.css({
            opacity: i.timerOpacity,
            width: m,
            height: f
        }),
        o.setTimerPosition(),
        new r(o.defs.images,function(e) {
            var t = 10 * e;
            d.stop().animate({
                width: t + "%"
            })
        }
        ,function() {
            d.stop().animate({
                width: "100%"
            }, function() {
                s.remove(),
                o.startSlider(),
                i.onAfterLoad.call(this)
            }
            )
        }
        ),
        o.sliderContent.bind("swipeleft", function() {
            return o.defs.lock ? !1 : (o.cleanTimer(),
            o.cleanCaptionTimer(),
            o.hideCaption(o.options),
            void o.goTo("next"))
        }
        ).bind("swiperight", function() {
            return o.defs.lock ? !1 : (o.cleanTimer(),
            o.cleanCaptionTimer(),
            o.hideCaption(o.options),
            o.defs.slide -= 2,
            void o.goTo("prev"))
        }
        ),
        i.keyboardNav && e(document).bind("keyup.iView", function(e) {
            if ("37" == e.keyCode) {
                if (o.defs.lock)
                    return !1;
                o.cleanTimer(),
                o.cleanCaptionTimer(),
                o.hideCaption(o.options),
                o.defs.slide -= 2,
                o.goTo("prev")
            }
            if ("39" == e.keyCode) {
                if (o.defs.lock)
                    return !1;
                o.cleanTimer(),
                o.cleanCaptionTimer(),
                o.hideCaption(o.options),
                o.goTo("next")
            }
        }
        ),
        o.iviewTimer.on("click", function() {
            o.iviewTimer.hasClass("paused") ? o.playSlider() : o.stopSlider()
        }
        ),
        o.sliderContent.bind("iView:pause", function() {
            o.stopSlider()
        }
        ),
        o.sliderContent.bind("iView:play", function() {
            o.playSlider()
        }
        ),
        o.sliderContent.bind("iView:previous", function() {
            return o.defs.lock ? !1 : (o.cleanTimer(),
            o.cleanCaptionTimer(),
            o.hideCaption(o.options),
            o.defs.slide -= 2,
            void o.goTo("prev"))
        }
        ),
        o.sliderContent.bind("iView:next", function() {
            return o.defs.lock ? !1 : (o.cleanTimer(),
            o.cleanCaptionTimer(),
            o.hideCaption(o.options),
            void o.goTo("next"))
        }
        ),
        o.sliderContent.bind("iView:goSlide", function(t, i) {
            return o.defs.lock || o.defs.slide == i ? !1 : e(this).hasClass("active") ? !1 : (o.cleanTimer(),
            o.cleanCaptionTimer(),
            o.hideCaption(o.options),
            !o.defs.image.data("iviewimage") && "undefined" != typeof o.defs.image.data("bgcolor") && o.defs.image.data("bgcolor") ? (o.slider.css("background-image", 'url("' + o.defs.image.data("iviewimage") + '")'),
            o.slider.css("background-repeat", "no-repeat"),
            o.slider.css("background-color", "initial"),
            "undefined" != typeof o.defs.image.data("bgcolor") && o.defs.image.data("bgcolor") && o.slider.css("background-color", o.defs.image.data("bgcolor"))) : o.slider.css("background", 'url("' + o.defs.image.data("iviewimage") + '") no-repeat'),
            o.defs.slide = i - 1,
            void o.goTo("control"))
        }
        ),
        o.sliderContent.bind("resize", function() {
            if (b = e(this),
            tW = b.width(),
            tH = b.height(),
            m = o.slider.width(),
            f = o.slider.height(),
            o.defs.width != tW) {
                var t = tW / m
                  , i = Math.round(o.defs.height * t);
                o.slider.css({
                    "-webkit-transform-origin": "0 0",
                    "-moz-transform-origin": "0 0",
                    "-o-transform-origin": "0 0",
                    "-ms-transform-origin": "0 0",
                    "transform-origin": "0 0",
                    "-webkit-transform": "scale(" + t + ")",
                    "-moz-transform": "scale(" + t + ")",
                    "-o-transform": "scale(" + t + ")",
                    "-ms-transform": "scale(" + t + ")",
                    transform: "scale(" + t + ")"
                }),
                b.css({
                    height: i
                }),
                o.defs.width = tW,
                o.setTimerPosition(),
                o.options.directionPosition && "verticalcentered" == o.options.directionPosition && (o.options.prevId && e(o.options.prevId).length > 0 && e(o.options.prevId).css({
                    position: "absolute",
                    "margin-top": o.options.prevMarginTop,
                    left: o.options.prevLeft,
                    top: i / 2 - e(o.options.prevId).height() / 2 + "px"
                }),
                o.options.nextId && e(o.options.nextId).length > 0 && e(o.options.nextId).css({
                    position: "absolute",
                    "margin-top": o.options.nextMarginTop,
                    right: o.options.nextRight,
                    top: i / 2 - e(o.options.nextId).height() / 2 + "px"
                }))
            }
        }
        ),
        e(".iview-video", o.slider).click(function(t) {
            var i = e(this)
              , a = e(".iview-video-show", i);
            e(t.target).hasClass("iview-video-close") || e(t.target).hasClass("iview-caption") || e(t.target).parents().hasClass("iview-caption") || (a.show().animate({
                top: 0
            }, 1e3, "easeOutBounce"),
            o.sliderContent.trigger("iView:pause"))
        }
        ),
        o.slides.eq(o.defs.slide).length > 0 && o.slides.eq(o.defs.slide).data("iviewvideoplay")) {
            var b = o.slides.eq(o.defs.slide)
              , k = e(".iview-video-show", b)
              , _ = e("iframe", k)
              , y = _.attr("src");
            y.indexOf("autoplay=1") <= 0 && (y += "&autoplay=1"),
            _.attr("src", y),
            o.slides.eq(o.defs.slide).trigger("click")
        }
        e(".iview-video-close", o.slider).click(function() {
            var t = e(this).parents(".iview-video-show")
              , i = e("iframe", t)
              , a = i.attr("src");
            i.removeAttr("src").attr("src", a),
            t.animate({
                top: "-" + o.defs.height + "px"
            }, 1e3, "easeOutBounce", function() {
                t.hide(),
                o.sliderContent.trigger("iView:play")
            }
            )
        }
        )
    }
    ;
    s.prototype = {
        timer: null ,
        caption_start_timer: [],
        caption_contain_start_timer: [],
        caption_end_timer: [],
        caption_contain_end_timer: [],
        start_time: [],
        end_time: [],
        startSlider: function() {
            var t = this
              , i = new Image;
            if (i.src = t.slides.eq(0).data("iviewimage"),
            imgWidth = i.width,
            (imgWidth != t.defs.width || a() || imgWidth != e(t.sliderContent).width()) && (t.defs.width = imgWidth,
            t.sliderContent.trigger("resize")),
            t.iviewTimer.show(),
            t.slides.eq(t.defs.slide).css("display", "block"),
            !t.defs.image.data("iviewimage") && "undefined" != typeof t.defs.image.data("bgcolor") && t.defs.image.data("bgcolor") ? (t.slider.css("background-image", 'url("' + t.defs.image.data("iviewimage") + '")'),
            t.slider.css("background-repeat", "no-repeat"),
            t.slider.css("background-color", "initial"),
            "undefined" != typeof t.defs.image.data("bgcolor") && t.defs.image.data("bgcolor") && t.slider.css("background-color", t.defs.image.data("bgcolor"))) : t.slider.css("background", 'url("' + t.defs.image.data("iviewimage") + '") no-repeat'),
            t.setCaption(t.options),
            t.options.autoAdvance && t.setCaptionEnd(t.options),
            t.iviewTimer.addClass("paused").attr("title", t.options.playLabel),
            t.options.autoAdvance && t.defs.total > 1 && (t.iviewTimer.removeClass("paused").attr("title", t.options.pauseLabel),
            t.setTimer()),
            t.options.showThumbInControl && t.setNextPrevThumbnail(),
            t.options.directionNav) {
                var o = "undefined" != typeof t.options.prevClass ? t.options.prevClass : ""
                  , n = "undefined" != typeof t.options.nextClass ? t.options.nextClass : "";
                t.sliderContent.append('<div class="iview-directionNav"><a class="iview-prevNav ' + o + '" title="' + t.options.previousLabel + '">' + t.options.previousLabel + '</a><a class="iview-nextNav ' + n + '" title="' + t.options.nextLabel + '">' + t.options.nextLabel + "</a></div>"),
                e(".iview-directionNav", t.sliderContent).css({
                    opacity: t.options.directionNavHoverOpacity
                }),
                t.sliderContent.hover(function() {
                    e(".iview-directionNav", t.sliderContent).stop().animate({
                        opacity: 1
                    }, 300)
                }
                , function() {
                    e(".iview-directionNav", t.sliderContent).stop().animate({
                        opacity: t.options.directionNavHoverOpacity
                    }, 300)
                }
                ),
                e("a.iview-prevNav", t.sliderContent).on("click", function() {
                    return t.defs.lock ? !1 : (t.cleanTimer(),
                    t.cleanCaptionTimer(),
                    t.hideCaption(t.options),
                    t.defs.slide -= 2,
                    void t.goTo("prev"))
                }
                ),
                e("a.iview-nextNav", t.sliderContent).on("click", function() {
                    return t.defs.lock ? !1 : (t.cleanTimer(),
                    t.cleanCaptionTimer(),
                    t.hideCaption(t.options),
                    void t.goTo("next"))
                }
                )
            }
            if (t.options.controlNav) {
                var s = '<div class="iview-controlNav">'
                  , r = "";
                !t.options.directionNav && t.options.controlNavNextPrev && (s += '<a class="iview-controlPrevNav" title="' + t.options.previousLabel + '">' + t.options.previousLabel + "</a>"),
                s += '<div class="iview-items"><ul>';
                for (var d = 0; d < t.defs.total; d++) {
                    var p = t.slides.eq(d);
                    if (s += "<li>",
                    t.options.controlNavThumbs) {
                        var c = p.data(p.data("iviewthumbnail") ? "iviewthumbnail" : "iviewimage");
                        s += '<a class="iview-control" rel="' + d + '"><img src="' + c + '" /></a>'
                    } else {
                        var c = p.data(p.data("iviewthumbnail") ? "iviewthumbnail" : "iviewimage");
                        s += '<a class="iview-control" rel="' + d + '">' + (d + 1) + "</a>",
                        t.options.controlNavTooltip && (r += '<div rel="' + d + '"><img src="' + c + '" /></div>')
                    }
                    s += "</li>"
                }
                s += "</ul></div>",
                !t.options.directionNav && t.options.controlNavNextPrev && (s += '<a class="iview-controlNextNav" title="' + t.options.nextLabel + '">' + t.options.nextLabel + "</a>"),
                s += "</div>",
                !t.options.controlNavThumbs && t.options.controlNavTooltip && (s += '<div id="iview-tooltip"><div class="holder"><div class="container">' + r + "</div></div></div>"),
                t.sliderContent.append(s),
                e(".iview-controlNav a.iview-control:eq(" + t.defs.slide + ")", t.sliderContent).addClass("active"),
                e("a.iview-controlPrevNav", t.sliderContent).on("click", function() {
                    return t.defs.lock ? !1 : (t.cleanTimer(),
                    t.cleanCaptionTimer(),
                    t.hideCaption(t.options),
                    t.defs.slide -= 2,
                    void t.goTo("prev"))
                }
                ),
                e("a.iview-controlNextNav", t.sliderContent).on("click", function() {
                    return t.defs.lock ? !1 : (t.cleanTimer(),
                    t.cleanCaptionTimer(),
                    t.hideCaption(t.options),
                    void t.goTo("next"))
                }
                ),
                e(".iview-controlNav a.iview-control", t.sliderContent).on("click", function() {
                    return t.defs.lock ? !1 : e(this).hasClass("active") ? !1 : (t.cleanTimer(),
                    t.cleanCaptionTimer(),
                    t.hideCaption(t.options),
                    !t.defs.image.data("iviewimage") && "undefined" != typeof t.defs.image.data("bgcolor") && t.defs.image.data("bgcolor") ? (t.slider.css("background-image", 'url("' + t.defs.image.data("iviewimage") + '")'),
                    t.slider.css("background-repeat", "no-repeat"),
                    t.slider.css("background-color", "initial"),
                    "undefined" != typeof t.defs.image.data("bgcolor") && t.defs.image.data("bgcolor") && t.slider.css("background-color", t.defs.image.data("bgcolor"))) : t.slider.css("background", 'url("' + t.defs.image.data("iviewimage") + '") no-repeat'),
                    t.defs.slide = e(this).attr("rel") - 1,
                    void t.goTo("control"))
                }
                ),
                e(".iview-controlNav", t.sliderContent).css({
                    opacity: t.options.controlNavHoverOpacity
                }),
                t.sliderContent.hover(function() {
                    e(".iview-controlNav", t.sliderContent).stop().animate({
                        opacity: 1
                    }, 300),
                    t.sliderContent.addClass("iview-hover")
                }
                , function() {
                    e(".iview-controlNav", t.sliderContent).stop().animate({
                        opacity: t.options.controlNavHoverOpacity
                    }, 300),
                    t.sliderContent.removeClass("iview-hover")
                }
                );
                var l = null ;
                e(".iview-controlNav a.iview-control", t.sliderContent).hover(function() {
                    var i = e(this)
                      , o = i.attr("rel")
                      , a = e("#iview-tooltip", t.sliderContent)
                      , n = e("div.holder", a)
                      , s = i.offset().left - t.sliderContent.offset().left - a.outerWidth() / 2 + t.options.tooltipX
                      , r = i.offset().top - t.sliderContent.offset().top - a.outerHeight() + t.options.tooltipY
                      , d = e("div[rel=" + o + "]");
                    scrollLeft = o * d.width(),
                    a.stop().animate({
                        left: s,
                        top: r,
                        opacity: 1
                    }, 300),
                    a.not(":visible") && a.fadeIn(300),
                    n.stop().animate({
                        scrollLeft: scrollLeft
                    }, 300),
                    clearTimeout(l)
                }
                , function() {
                    var i = e("#iview-tooltip", t.sliderContent);
                    l = setTimeout(function() {
                        i.animate({
                            opacity: 0
                        }, 300, function() {
                            i.hide()
                        }
                        )
                    }
                    , 200)
                }
                )
            }
            t.sliderContent.bind("mouseover.iView mousemove.iView", function() {
                t.options.pauseOnHover && !t.defs.paused && (t.cleanTimer(),
                t.pauseCaptionTimer()),
                t.sliderContent.addClass("iview-hover")
            }
            ).bind("mouseout.iView", function() {
                t.options.pauseOnHover && !t.defs.paused && null  == t.timer && t.pieDegree <= 359 && t.options.autoAdvance && (t.setTimer(),
                t.resumeCaptionTimer()),
                t.sliderContent.removeClass("iview-hover")
            }
            )
        },
        customAnimation: function(t, i, o, a) {
            var n = this;
            e(t).css({
                opacity: n.options.captionOpacity
            }),
            e(t).removeClass(i).removeClass("animated").addClass(i + " animated").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function() {
                e(this).removeClass(i).removeClass("animated")
            }
            )
        },
        customAnimationEnd: function(t, i, o, a, n) {
            e(t).removeClass(o).removeClass("animated").addClass(o + " animated").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function() {
                e(this).removeClass(o).removeClass("animated"),
                e(t).css({
                    opacity: 0
                }),
                e(i).css({
                    opacity: 0
                })
            }
            )
        },
        setCaptionEnd: function(t, i, a) {
            var a = a || null 
              , i = i || !1
              , n = this
              , s = n.slides.eq(n.defs.slide)
              , r = e(".iview-caption", s)
              , d = 0;
            r.each(function(t) {
                if (null  === a || t != a) {
                    var s = e(this)
                      , r = s.data("endtransition") ? e.trim(s.data("endtransition").toLowerCase()) : "fade"
                      , p = s.data("endtransition") ? e.trim(s.data("endtransition")) : "fade"
                      , c = s.data("endspeed") ? s.data("endspeed") : n.options.captionSpeed
                      , l = s.data("endeasing") ? s.data("endeasing") : n.options.captionEasing
                      , m = s.data("start") ? s.data("start") : 0
                      , f = s.data("end") ? s.data("end") : 0
                      , h = "undefined" != s.data("x") ? s.data("x") : "center"
                      , u = "undefined" != s.data("y") ? s.data("y") : "center"
                      , g = s.data("width") ? s.data("width") : s.width()
                      , v = s.data("height") ? s.data("height") : s.height()
                      , w = s.outerWidth()
                      , b = s.outerHeight();
                    "center" == h && (h = n.defs.width / 2 - w / 2),
                    "center" == u && (u = n.defs.height / 2 - b / 2);
                    var k = e(".caption-contain", s);
                    d = parseInt(f) + parseInt(m);
                    var _ = n.defs.time;
                    switch (("undefined" == typeof _ || 0 == _) && (_ = 5e3),
                    d = d * _ / 29e3,
                    i && (d = 0),
                    r) {
                    case "wipebottom":
                    case "wipedown":
                        n.caption_end_timer[t] = new o(function() {
                            s.animate({
                                opacity: 0,
                                top: u - v,
                                left: h,
                                width: g,
                                height: v
                            }, c, l, function() {}
                            )
                        }
                        ,d,parseInt(m)),
                        n.caption_contain_end_timer[t] = new o(function() {
                            k.animate({
                                opacity: 0,
                                top: v + 3 * v,
                                left: 0
                            }, c, l)
                        }
                        ,d + 100,parseInt(m));
                        break;
                    case "wipetop":
                    case "wipeup":
                        n.caption_end_timer[t] = new o(function() {
                            s.animate({
                                opacity: 0,
                                top: u + v,
                                left: h,
                                width: g,
                                height: v
                            }, c, l, function() {}
                            )
                        }
                        ,d,parseInt(m)),
                        n.caption_contain_end_timer[t] = new o(function() {
                            k.animate({
                                opacity: 0,
                                top: v - 3 * v,
                                left: 0
                            }, c, l)
                        }
                        ,d + 100,parseInt(m));
                        break;
                    case "wiperight":
                        n.caption_end_timer[t] = new o(function() {
                            s.animate({
                                opacity: 0,
                                top: u,
                                left: h - g,
                                width: g,
                                height: v
                            }, c, l, function() {}
                            )
                        }
                        ,d,parseInt(m)),
                        n.caption_contain_end_timer[t] = new o(function() {
                            k.animate({
                                opacity: 0,
                                top: 0,
                                left: g + 2 * g
                            }, c, l)
                        }
                        ,d + 100,parseInt(m));
                        break;
                    case "wipeleft":
                        n.caption_end_timer[t] = new o(function() {
                            s.animate({
                                opacity: 0,
                                top: u,
                                left: h + g,
                                width: g,
                                height: v
                            }, c, l, function() {}
                            )
                        }
                        ,d,parseInt(m)),
                        n.caption_contain_end_timer[t] = new o(function() {
                            k.animate({
                                opacity: 0,
                                top: 0,
                                left: g - 2 * g
                            }, c, l)
                        }
                        ,d + 100,parseInt(m));
                        break;
                    case "fade":
                        n.caption_end_timer[t] = new o(function() {
                            s.animate({
                                opacity: 0,
                                top: u,
                                left: h,
                                width: g,
                                height: v
                            }, c, l, function() {}
                            )
                        }
                        ,d,parseInt(m)),
                        n.caption_contain_end_timer[t] = new o(function() {
                            k.animate({
                                opacity: 0,
                                top: 0,
                                left: 0
                            }, c, l)
                        }
                        ,d + 100,parseInt(m));
                        break;
                    case "expandbottom":
                    case "expanddown":
                        n.caption_end_timer[t] = new o(function() {
                            s.animate({
                                opacity: 0,
                                top: u,
                                left: h,
                                height: 0,
                                width: g
                            }, c, l, function() {}
                            )
                        }
                        ,d,parseInt(m)),
                        n.caption_contain_end_timer[t] = new o(function() {
                            k.animate({
                                opacity: 0,
                                top: v + 3 * v,
                                left: 0
                            }, c, l)
                        }
                        ,d + 100,parseInt(m));
                        break;
                    case "expandtop":
                    case "expandup":
                        n.caption_end_timer[t] = new o(function() {
                            s.animate({
                                opacity: 0,
                                top: u + v,
                                left: h,
                                height: 0,
                                width: g
                            }, c, l, function() {}
                            )
                        }
                        ,d,parseInt(m)),
                        n.caption_contain_end_timer[t] = new o(function() {
                            k.animate({
                                opacity: 0,
                                top: v - 3 * v,
                                left: 0
                            }, c, l)
                        }
                        ,d + 100,parseInt(m));
                        break;
                    case "expandright":
                        n.caption_end_timer[t] = new o(function() {
                            s.animate({
                                opacity: 0,
                                top: u,
                                left: h,
                                width: 0,
                                height: v
                            }, c, l, function() {}
                            )
                        }
                        ,d,parseInt(m)),
                        n.caption_contain_end_timer[t] = new o(function() {
                            k.animate({
                                opacity: 0,
                                top: 0,
                                left: g + 2 * g
                            }, c, l)
                        }
                        ,d + 100,parseInt(m));
                        break;
                    case "expandleft":
                        n.caption_end_timer[t] = new o(function() {
                            s.animate({
                                opacity: 0,
                                top: u,
                                left: h + g,
                                width: 0,
                                height: v
                            }, c, l, function() {}
                            )
                        }
                        ,d,parseInt(m)),
                        n.caption_contain_end_timer[t] = new o(function() {
                            k.animate({
                                opacity: 0,
                                top: 0,
                                left: g - 2 * g
                            }, c, l)
                        }
                        ,d + 100,parseInt(m));
                        break;
                    default:
                        if (r.match(/custom./gi)) {
                            var y = p.replace("custom.", "");
                            n.caption_end_timer[t] = new o(function() {
                                n.customAnimationEnd(s, k, y, c, l)
                            }
                            ,d,parseInt(m))
                        }
                    }
                }
            }
            )
        },
        setCaption: function(t, i) {
            var i = i || null 
              , a = this
              , n = a.slides.eq(a.defs.slide)
              , s = e(".iview-caption", n)
              , r = 0
              , d = 0;
            s.each(function(t) {
                if (null  === i || t != i) {
                    var n = e(this)
                      , s = n.data("transition") ? e.trim(n.data("transition").toLowerCase()) : "fade"
                      , p = n.data("transition") ? e.trim(n.data("transition")) : "fade"
                      , c = n.data("speed") ? n.data("speed") : a.options.captionSpeed
                      , l = n.data("easing") ? n.data("easing") : a.options.captionEasing
                      , m = (n.data("endtransition") ? e.trim(n.data("endtransition").toLowerCase()) : "fade",
                    n.data("endtransition") ? e.trim(n.data("endtransition")) : "fade",
                    n.data("endspeed") ? n.data("endspeed") : a.options.captionSpeed,
                    n.data("endeasing") ? n.data("endeasing") : a.options.captionEasing,
                    n.data("start") ? n.data("start") : 0)
                      , f = n.data("end") ? n.data("end") : 0
                      , h = "undefined" != n.data("x") ? n.data("x") : "center"
                      , u = "undefined" != n.data("y") ? n.data("y") : "center"
                      , g = n.data("width") ? n.data("width") : n.width()
                      , v = n.data("height") ? n.data("height") : n.height()
                      , w = n.outerWidth()
                      , b = n.outerHeight();
                    "center" == h && (h = a.defs.width / 2 - w / 2),
                    "center" == u && (u = a.defs.height / 2 - b / 2);
                    var k = e(".caption-contain", n);
                    r = parseInt(m),
                    d = parseInt(f);
                    var _ = a.defs.time;
                    switch (("undefined" == typeof _ || 0 == _) && (_ = 5e3),
                    r = r * _ / 29e3,
                    n.css({
                        opacity: 0
                    }),
                    k.css({
                        opacity: 0,
                        position: "relative",
                        width: g,
                        height: v
                    }),
                    s) {
                    case "wipebottom":
                    case "wipedown":
                        n.css({
                            top: u - v,
                            left: h
                        }),
                        k.css({
                            top: v + 3 * v,
                            left: 0
                        });
                        break;
                    case "wipetop":
                    case "wipeup":
                        n.css({
                            top: u + v,
                            left: h
                        }),
                        k.css({
                            top: v - 3 * v,
                            left: 0
                        });
                        break;
                    case "wiperight":
                        n.css({
                            top: u,
                            left: h - g
                        }),
                        k.css({
                            top: 0,
                            left: g + 2 * g
                        });
                        break;
                    case "wipeleft":
                        n.css({
                            top: u,
                            left: h + g
                        }),
                        k.css({
                            top: 0,
                            left: g - 2 * g
                        });
                        break;
                    case "fade":
                        n.css({
                            top: u,
                            left: h
                        }),
                        k.css({
                            top: 0,
                            left: 0
                        });
                        break;
                    case "expandbottom":
                    case "expanddown":
                        n.css({
                            top: u,
                            left: h,
                            height: 0
                        }),
                        k.css({
                            top: v + 3 * v,
                            left: 0
                        });
                        break;
                    case "expantop":
                    case "expandup":
                        n.css({
                            top: u + v,
                            left: h,
                            height: 0
                        }),
                        k.css({
                            top: v - 3 * v,
                            left: 0
                        });
                        break;
                    case "expandright":
                        n.css({
                            top: u,
                            left: h,
                            width: 0
                        }),
                        k.css({
                            top: 0,
                            left: g + 2 * g
                        });
                        break;
                    case "expandleft":
                        n.css({
                            top: u,
                            left: h + g,
                            width: 0
                        }),
                        k.css({
                            top: 0,
                            left: g - 2 * g
                        })
                    }
                    if (s.match(/custom./gi)) {
                        var y = p.replace("custom.", "");
                        n.css({
                            top: u,
                            left: h,
                            width: g,
                            height: v
                        }),
                        k.css({
                            top: 0,
                            left: 0,
                            opacity: a.options.captionOpacity
                        }),
                        a.caption_start_timer[t] = new o(function() {
                            a.customAnimation(n, y, c, l)
                        }
                        ,r,parseInt(m))
                    } else
                        a.caption_start_timer[t] = new o(function() {
                            n.animate({
                                opacity: a.options.captionOpacity,
                                top: u,
                                left: h,
                                width: g,
                                height: v
                            }, c, l, function() {}
                            )
                        }
                        ,r,parseInt(m)),
                        a.caption_contain_start_timer[t] = new o(function() {
                            k.animate({
                                opacity: a.options.captionOpacity,
                                top: 0,
                                left: 0
                            }, c, l)
                        }
                        ,r + 100,parseInt(m))
                }
            }
            )
        },
        hideCaption: function(t) {
            var i = this
              , o = i.slides.eq(i.defs.slide)
              , a = e(".iview-caption", o);
            a.each(function() {
                var t = e(this)
                  , o = t.data("endspeed") ? t.data("endspeed") : i.options.captionSpeed
                  , a = t.data("endeasing") ? t.data("endeasing") : i.options.captionEasing
                  , n = e(".caption-contain", t);
                t.animate({
                    opacity: 0
                }, o, a),
                n.animate({
                    opacity: 0
                }, o, a)
            }
            )
        },
        processTimer: function() {
            var e = this;
            if ("360bar" == e.defs.timer) {
                var t = 0 == e.pieDegree ? 0 : e.pieDegree + .9;
                e.timerPath.attr({
                    arc: [t, e.R]
                })
            } else if ("pie" == e.defs.timer) {
                var t = 0 == e.pieDegree ? 0 : e.pieDegree + .9;
                e.pieTimer.attr({
                    segment: [t, e.R]
                })
            } else
                e.barTimer.css({
                    width: e.pieDegree / 360 * 100 + "%"
                });
            e.pieDegree += 3
        },
        transitionEnd: function(t) {
            if (t.options.onAfterChange.call(this),
            t.slides.eq(t.defs.slide).data("iviewvideoplay")) {
                var i = t.slides.eq(t.defs.slide)
                  , o = e(".iview-video-show", i)
                  , a = e("iframe", o)
                  , n = a.attr("src");
                n.indexOf("autoplay=1") <= 0 && (n += "&autoplay=1"),
                a.attr("src", n),
                t.slides.eq(t.defs.slide).trigger("click")
            }
            t.defs.lock = !1,
            t.slides.css("display", "none"),
            t.slides.eq(t.defs.slide).show(),
            !t.defs.image.data("iviewimage") && "undefined" != typeof t.defs.image.data("bgcolor") && t.defs.image.data("bgcolor") ? (t.slider.css("background-image", 'url("' + t.defs.image.data("iviewimage") + '")'),
            t.slider.css("background-repeat", "no-repeat"),
            t.slider.css("background-color", "initial"),
            "undefined" != typeof t.defs.image.data("bgcolor") && t.defs.image.data("bgcolor") && t.slider.css("background-color", t.defs.image.data("bgcolor"))) : t.slider.css("background", 'url("' + t.defs.image.data("iviewimage") + '") no-repeat'),
            e(".iview-strip, .iview-block", t.slider).remove(),
            t.defs.time = t.defs.image.data("iviewpausetime") ? t.defs.image.data("iviewpausetime") : t.options.pauseTime,
            t.iviewTimer.animate({
                opacity: t.options.timerOpacity
            }),
            t.pieDegree = 0,
            t.processTimer(),
            t.setCaption(t.options),
            t.options.autoAdvance && t.setCaptionEnd(t.options),
            null  != t.timer || t.defs.paused || (t.timer = setInterval(function() {
                t.timerCall(t)
            }
            , t.defs.time / 120))
        },
        addStrips: function(t, i) {
            var o = this;
            i = i ? i : o.options;
            for (var a = 0; a < i.strips; a++) {
                var n = Math.round(o.slider.width() / i.strips)
                  , s = Math.round(o.slider.height() / i.strips)
                  , r = "-" + (n + a * n - n) + "px 0%"
                  , d = t ? s * a + "px" : "0px"
                  , p = t ? "0px" : n * a + "px";
                if (t && (r = "0% -" + (s + a * s - s) + "px"),
                a == i.strips - 1)
                    var c = t ? "0px" : o.slider.width() - n * a + "px"
                      , l = t ? o.slider.height() - s * a + "px" : "0px";
                else
                    var c = t ? "0px" : n + "px"
                      , l = t ? s + "px" : "0px";
                var m = "initial";
                if ("undefined" != typeof o.defs.image.data("bgcolor") && o.defs.image.data("bgcolor") && (m = o.defs.image.data("bgcolor")),
                !o.defs.image.data("iviewimage") && "undefined" != typeof o.defs.image.data("bgcolor") && o.defs.image.data("bgcolor"))
                    var f = e('<div class="iview-strip"></div>').css({
                        width: c,
                        height: l,
                        top: d,
                        left: p,
                        "background-image": 'url("' + o.defs.image.data("iviewimage") + '")',
                        "background-repeat": "no-repeat",
                        "background-position": r,
                        "background-color": m,
                        opacity: 0
                    });
                else
                    var f = e('<div class="iview-strip"></div>').css({
                        width: c,
                        height: l,
                        top: d,
                        left: p,
                        background: 'url("' + o.defs.image.data("iviewimage") + '") no-repeat ' + r,
                        opacity: 0
                    });
                o.slider.append(f)
            }
        },
        addBlocks: function() {
            for (var t = this, i = Math.round(t.slider.width() / t.options.blockCols), o = Math.round(t.slider.height() / t.options.blockRows), a = 0; a < t.options.blockRows; a++)
                for (var n = 0; n < t.options.blockCols; n++) {
                    var s = i + "px"
                      , r = "-" + (i + n * i - i) + "px -" + (o + a * o - o) + "px";
                    n == t.options.blockCols - 1 && (s = t.slider.width() - i * n + "px");
                    var d = "initial";
                    if ("undefined" != typeof t.defs.image.data("bgcolor") && t.defs.image.data("bgcolor") && (d = t.defs.image.data("bgcolor")),
                    !t.defs.image.data("iviewimage") && "undefined" != typeof t.defs.image.data("bgcolor") && t.defs.image.data("bgcolor"))
                        var p = e('<div class="iview-block"></div>').css({
                            width: i + "px",
                            height: o + "px",
                            top: a * o + "px",
                            left: n * i + "px",
                            "background-image": 'url("' + t.defs.image.data("iviewimage") + '")',
                            "background-repeat": "no-repeat",
                            "background-position": r,
                            "background-color": d,
                            opacity: 0
                        });
                    else
                        var p = e('<div class="iview-block"></div>').css({
                            width: i + "px",
                            height: o + "px",
                            top: a * o + "px",
                            left: n * i + "px",
                            background: 'url("' + t.defs.image.data("iviewimage") + '") no-repeat ' + r,
                            opacity: 0
                        });
                    t.slider.append(p)
                }
        },
        runTransition: function(t) {
            var i = this;
            switch (t) {
            case "strip-up-right":
            case "strip-up-left":
                i.addStrips();
                var o = 0;
                a = 0,
                n = e(".iview-strip", i.slider),
                "strip-up-left" == t && (n = e(".iview-strip", i.slider).reverse()),
                n.each(function() {
                    var t = e(this);
                    t.css({
                        top: "",
                        bottom: "0px"
                    }),
                    setTimeout(function() {
                        t.animate({
                            height: "100%",
                            opacity: "1.0"
                        }, i.options.animationSpeed, i.defs.easing, function() {
                            a == i.options.strips - 1 && i.transitionEnd(i),
                            a++
                        }
                        )
                    }
                    , 100 + o),
                    o += 50
                }
                );
                break;
            case "strip-down":
            case "strip-down-right":
            case "strip-down-left":
                i.addStrips();
                var o = 0
                  , a = 0
                  , n = e(".iview-strip", i.slider);
                "strip-down-left" == t && (n = e(".iview-strip", i.slider).reverse()),
                n.each(function() {
                    var t = e(this);
                    t.css({
                        bottom: "",
                        top: "0px"
                    }),
                    setTimeout(function() {
                        t.animate({
                            height: "100%",
                            opacity: "1.0"
                        }, i.options.animationSpeed, i.defs.easing, function() {
                            a == i.options.strips - 1 && i.transitionEnd(i),
                            a++
                        }
                        )
                    }
                    , 100 + o),
                    o += 50
                }
                );
                break;
            case "strip-left-right":
            case "strip-left-right-up":
            case "strip-left-right-down":
                i.addStrips(!0);
                var o = 0
                  , a = 0
                  , s = 0
                  , n = e(".iview-strip", i.slider);
                "strip-left-right-down" == t && (n = e(".iview-strip", i.slider).reverse()),
                n.each(function() {
                    var t = e(this);
                    0 == a ? (t.css({
                        right: "",
                        left: "0px"
                    }),
                    a++) : (t.css({
                        left: "",
                        right: "0px"
                    }),
                    a = 0),
                    setTimeout(function() {
                        t.animate({
                            width: "100%",
                            opacity: "1.0"
                        }, i.options.animationSpeed, i.defs.easing, function() {
                            s == i.options.strips - 1 && i.transitionEnd(i),
                            s++
                        }
                        )
                    }
                    , 100 + o),
                    o += 50
                }
                );
                break;
            case "strip-up-down":
            case "strip-up-down-right":
            case "strip-up-down-left":
                i.addStrips();
                var o = 0
                  , a = 0
                  , s = 0
                  , n = e(".iview-strip", i.slider);
                "strip-up-down-left" == t && (n = e(".iview-strip", i.slider).reverse()),
                n.each(function() {
                    var t = e(this);
                    0 == a ? (t.css({
                        bottom: "",
                        top: "0px"
                    }),
                    a++) : (t.css({
                        top: "",
                        bottom: "0px"
                    }),
                    a = 0),
                    setTimeout(function() {
                        t.animate({
                            height: "100%",
                            opacity: "1.0"
                        }, i.options.animationSpeed, i.defs.easing, function() {
                            s == i.options.strips - 1 && i.transitionEnd(i),
                            s++
                        }
                        )
                    }
                    , 100 + o),
                    o += 50
                }
                );
                break;
            case "left-curtain":
            case "right-curtain":
            case "top-curtain":
            case "bottom-curtain":
                "left-curtain" == t || "right-curtain" == t ? i.addStrips() : i.addStrips(!0);
                var o = 0
                  , a = 0
                  , n = e(".iview-strip", i.slider);
                ("right-curtain" == t || "bottom-curtain" == t) && (n = e(".iview-strip", i.slider).reverse()),
                n.each(function() {
                    var n = e(this)
                      , s = n.width()
                      , r = n.height();
                    n.css("left-curtain" == t || "right-curtain" == t ? {
                        top: "0px",
                        height: "100%",
                        width: "0px"
                    } : {
                        left: "0px",
                        height: "0px",
                        width: "100%"
                    }),
                    setTimeout(function() {
                        "left-curtain" == t || "right-curtain" == t ? n.animate({
                            width: s,
                            opacity: "1.0"
                        }, i.options.animationSpeed, i.defs.easing, function() {
                            a == i.options.strips - 1 && i.transitionEnd(i),
                            a++
                        }
                        ) : n.animate({
                            height: r,
                            opacity: "1.0"
                        }, i.options.animationSpeed, i.defs.easing, function() {
                            a == i.options.strips - 1 && i.transitionEnd(i),
                            a++
                        }
                        )
                    }
                    , 100 + o),
                    o += 50
                }
                );
                break;
            case "strip-up-right":
            case "strip-up-left":
                i.addStrips();
                var o = 0
                  , a = 0
                  , n = e(".iview-strip", i.slider);
                "strip-up-left" == t && (n = e(".iview-strip", i.slider).reverse()),
                n.each(function() {
                    var t = e(this);
                    t.css({
                        bottom: "0px"
                    }),
                    setTimeout(function() {
                        t.animate({
                            height: "100%",
                            opacity: "1.0"
                        }, i.options.animationSpeed, i.defs.easing, function() {
                            a == i.options.strips - 1 && i.transitionEnd(i),
                            a++
                        }
                        )
                    }
                    , 100 + o),
                    o += 50
                }
                );
                break;
            case "strip-left-fade":
            case "strip-right-fade":
            case "strip-top-fade":
            case "strip-bottom-fade":
                "strip-left-fade" == t || "strip-right-fade" == t ? i.addStrips() : i.addStrips(!0);
                var o = 0
                  , a = 0
                  , n = e(".iview-strip", i.slider);
                ("strip-right-fade" == t || "strip-bottom-fade" == t) && (n = e(".iview-strip", i.slider).reverse()),
                n.each(function() {
                    var n = e(this)
                      , s = n.width()
                      , r = n.height();
                    n.css("strip-left-fade" == t || "strip-right-fade" == t ? {
                        top: "0px",
                        height: "100%",
                        width: s
                    } : {
                        left: "0px",
                        height: r,
                        width: "100%"
                    }),
                    setTimeout(function() {
                        n.animate({
                            opacity: "1.0"
                        }, 1.7 * i.options.animationSpeed, i.defs.easing, function() {
                            a == i.options.strips - 1 && i.transitionEnd(i),
                            a++
                        }
                        )
                    }
                    , 100 + o),
                    o += 35
                }
                );
                break;
            case "slide-in-up":
            case "slide-in-down":
                opts = {
                    strips: 1
                },
                i.addStrips(!1, opts);
                var r = e(".iview-strip:first", i.slider)
                  , d = 0;
                d = "slide-in-up" == t ? "-" + i.defs.height + "px" : i.defs.height + "px",
                r.css({
                    top: d,
                    height: "100%",
                    width: i.defs.width
                }),
                r.animate({
                    top: "0px",
                    opacity: 1
                }, 2 * i.options.animationSpeed, i.defs.easing, function() {
                    i.transitionEnd(i)
                }
                );
                break;
            case "zigzag-top":
            case "zigzag-bottom":
            case "zigzag-grow-top":
            case "zigzag-grow-bottom":
            case "zigzag-drop-top":
            case "zigzag-drop-bottom":
                i.addBlocks();
                for (var p = i.options.blockCols * i.options.blockRows, o = 0, c = new Array, l = e(".iview-block", i.slider), m = 0; m < i.options.blockRows; m++) {
                    var f = m % 2
                      , h = m * i.options.blockCols
                      , u = (m + 1) * i.options.blockCols;
                    if (1 == f)
                        for (var g = u - 1; g >= h; g--)
                            c.push(e(l[g]));
                    else
                        for (var g = h; u > g; g++)
                            c.push(e(l[g]))
                }
                ("zigzag-bottom" == t || "zigzag-grow-bottom" == t || "zigzag-drop-bottom" == t) && c.reverse(),
                l.each(function(a) {
                    var n = e(c[a])
                      , s = n.height()
                      , r = n.width()
                      , d = n.css("top");
                    "zigzag-grow-top" == t || "zigzag-grow-bottom" == t ? n.width(0).height(0) : ("zigzag-drop-top" == t || "zigzag-drop-bottom" == t) && n.css({
                        top: "-=50"
                    }),
                    setTimeout(function() {
                        "zigzag-grow-top" == t || "zigzag-grow-bottom" == t ? n.animate({
                            opacity: "1",
                            height: s,
                            width: r
                        }, i.options.animationSpeed, i.defs.easing, function() {
                            a == p - 1 && i.transitionEnd(i)
                        }
                        ) : "zigzag-drop-top" == t || "zigzag-drop-bottom" == t ? n.animate({
                            top: d,
                            opacity: "1"
                        }, i.options.animationSpeed, i.defs.easing, function() {
                            a == p - 1 && i.transitionEnd(i)
                        }
                        ) : n.animate({
                            opacity: "1"
                        }, 2 * i.options.animationSpeed, "easeInOutExpo", function() {
                            a == p - 1 && i.transitionEnd(i)
                        }
                        )
                    }
                    , 100 + o),
                    o += 20
                }
                );
                break;
            case "block-fade":
            case "block-fade-reverse":
            case "block-expand":
            case "block-expand-reverse":
                i.addBlocks();
                var p = i.options.blockCols * i.options.blockRows
                  , a = 0
                  , o = 0
                  , v = 0
                  , w = 0
                  , c = new Array;
                c[v] = new Array;
                var l = e(".iview-block", i.slider);
                ("block-fade-reverse" == t || "block-expand-reverse" == t) && (l = e(".iview-block", i.slider).reverse()),
                l.each(function() {
                    c[v][w] = e(this),
                    w++,
                    w == i.options.blockCols && (v++,
                    w = 0,
                    c[v] = new Array)
                }
                );
                for (var g = 0; g < 2 * i.options.blockCols; g++) {
                    for (var b = g, m = 0; m < i.options.blockRows; m++)
                        b >= 0 && b < i.options.blockCols && !function() {
                            var n = e(c[m][b])
                              , s = n.width()
                              , r = n.height();
                            ("block-expand" == t || "block-expand-reverse" == t) && n.width(0).height(0),
                            setTimeout(function() {
                                n.animate({
                                    opacity: "1",
                                    width: s,
                                    height: r
                                }, i.options.animationSpeed / 1.3, i.defs.easing, function() {
                                    a == p - 1 && i.transitionEnd(i),
                                    a++
                                }
                                )
                            }
                            , 100 + o)
                        }
                        (),
                        b--;
                    o += 100
                }
                break;
            case "block-random":
            case "block-expand-random":
            case "block-drop-random":
                i.addBlocks();
                var p = i.options.blockCols * i.options.blockRows
                  , o = 0
                  , l = i.shuffle(e(".iview-block", i.slider));
                l.each(function(a) {
                    var n = e(this)
                      , s = n.height()
                      , r = n.width()
                      , d = n.css("top");
                    "block-expand-random" == t && n.width(0).height(0),
                    "block-drop-random" == t && n.css({
                        top: "-=50"
                    }),
                    setTimeout(function() {
                        n.animate({
                            top: d,
                            opacity: "1",
                            height: s,
                            width: r
                        }, i.options.animationSpeed, i.defs.easing, function() {
                            a == p - 1 && i.transitionEnd(i)
                        }
                        )
                    }
                    , 100 + o),
                    o += 20
                }
                );
                break;
            case "slide-in-right":
            case "slide-in-left":
            case "fade":
            default:
                opts = {
                    strips: 1
                },
                i.addStrips(!1, opts);
                var r = e(".iview-strip:first", i.slider);
                r.css({
                    height: "100%",
                    width: i.defs.width
                }),
                "slide-in-right" == t ? r.css({
                    height: "100%",
                    width: i.defs.width,
                    left: i.defs.width + "px",
                    right: ""
                }) : "slide-in-left" == t && r.css({
                    left: "-" + i.defs.width + "px"
                }),
                r.animate({
                    left: "0px",
                    opacity: 1
                }, 2 * i.options.animationSpeed, i.defs.easing, function() {
                    i.transitionEnd(i)
                }
                )
            }
        },
        shuffle: function(e) {
            for (var t = e.slice(), i = t.length, o = i; o--; ) {
                var a = parseInt(Math.random() * i)
                  , n = t[o];
                t[o] = t[a],
                t[a] = n
            }
            return t
        },
        timerCall: function(e) {
            e.processTimer(),
            e.pieDegree >= 360 && (e.cleanTimer(),
            e.cleanCaptionTimer(),
            e.goTo(!1))
        },
        setTimer: function() {
            var e = this;
            e.timer = setInterval(function() {
                e.timerCall(e)
            }
            , e.defs.time / 120)
        },
        pauseCaptionTimer: function() {
            var t = this
              , i = 120 * t.timer * t.options.pauseTime / 29e3;
            t.caption_end_timer.length > 0 && e.each(t.caption_end_timer, function(e) {
                null  != t.caption_end_timer[e] && t.caption_end_timer[e].pause(i),
                null  != t.caption_contain_end_timer[e] && t.caption_contain_end_timer[e].pause(i)
            }
            )
        },
        resumeCaptionTimer: function() {
            var t = this;
            t.caption_end_timer.length > 0 && e.each(t.caption_end_timer, function(e) {
                null  != t.caption_end_timer[e] && (t.caption_end_timer[e].resume(),
                null  != t.caption_contain_end_timer[e] && t.caption_contain_end_timer[e].resume())
            }
            )
        },
        cleanTimer: function() {
            var e = this;
            clearInterval(e.timer),
            e.timer = null 
        },
        cleanCaptionTimer: function() {
            var t = this;
            t.caption_start_timer.length > 0 && e.each(t.caption_start_timer, function(e) {
                null  != t.caption_start_timer[e] && (t.caption_start_timer[e].pause(),
                t.caption_start_timer[e] = null )
            }
            ),
            t.caption_contain_start_timer.length > 0 && e.each(t.caption_contain_start_timer, function(e) {
                null  != t.caption_contain_start_timer[e] && (t.caption_contain_start_timer[e].pause(),
                t.caption_contain_start_timer[e] = null )
            }
            ),
            t.caption_end_timer.length > 0 && e.each(t.caption_end_timer, function(e) {
                null  != t.caption_end_timer[e] && (t.caption_end_timer[e].pause(),
                t.caption_end_timer[e] = null )
            }
            ),
            t.caption_contain_end_timer.length > 0 && e.each(t.caption_contain_end_timer, function(e) {
                null  != t.caption_contain_end_timer[e] && (t.caption_contain_end_timer[e].pause(),
                t.caption_contain_end_timer[e] = null )
            }
            )
        },
        goTo: function(t) {
            var o = this;
            o.defs && o.defs.slide == o.defs.total - 1 && o.options.onLastSlide.call(this),
            o.cleanTimer(),
            o.cleanCaptionTimer(),
            o.iviewTimer.animate({
                opacity: 0
            }),
            o.options.onBeforeChange.call(this),
            t ? ("prev" == t || "next" == t) && (!o.defs.image.data("iviewimage") && "undefined" != typeof o.defs.image.data("bgcolor") && o.defs.image.data("bgcolor") ? (o.slider.css("background-image", 'url("' + o.defs.image.data("iviewimage") + '")'),
            o.slider.css("background-repeat", "no-repeat"),
            o.slider.css("background-color", "initial"),
            "undefined" != typeof o.defs.image.data("bgcolor") && o.defs.image.data("bgcolor") && o.slider.css("background-color", o.defs.image.data("bgcolor"))) : o.slider.css("background", 'url("' + o.defs.image.data("iviewimage") + '") no-repeat')) : !o.defs.image.data("iviewimage") && "undefined" != typeof o.defs.image.data("bgcolor") && o.defs.image.data("bgcolor") ? (o.slider.css("background-image", 'url("' + o.defs.image.data("iviewimage") + '")'),
            o.slider.css("background-repeat", "no-repeat"),
            o.slider.css("background-color", "initial"),
            "undefined" != typeof o.defs.image.data("bgcolor") && o.defs.image.data("bgcolor") && o.slider.css("background-color", o.defs.image.data("bgcolor"))) : o.slider.css("background", 'url("' + o.defs.image.data("iviewimage") + '") no-repeat'),
            o.defs.slide++,
            o.defs.slide == o.defs.total && (o.defs.slide = 0,
            o.options.onSlideShowEnd.call(this)),
            o.defs.slide < 0 && (o.defs.slide = o.defs.total - 1),
            o.defs.image = o.slides.eq(o.defs.slide),
            o.options.controlNav && (e(".iview-controlNav a.iview-control", o.sliderContent).removeClass("active"),
            e(".iview-controlNav a.iview-control:eq(" + o.defs.slide + ")", o.sliderContent).addClass("active"));
            var a = o.options.fx;
            if ("random" == o.options.fx.toLowerCase()) {
                var n = new Array("left-curtain","right-curtain","top-curtain","bottom-curtain","strip-down-right","strip-down-left","strip-up-right","strip-up-left","strip-up-down","strip-up-down-left","strip-left-right","strip-left-right-down","slide-in-right","slide-in-left","slide-in-up","slide-in-down","fade","block-random","block-fade","block-fade-reverse","block-expand","block-expand-reverse","block-expand-random","zigzag-top","zigzag-bottom","zigzag-grow-top","zigzag-grow-bottom","zigzag-drop-top","zigzag-drop-bottom","strip-left-fade","strip-right-fade","strip-top-fade","strip-bottom-fade","block-drop-random");
                a = n[Math.floor(Math.random() * (n.length + 1))],
                a == i && (a = "fade"),
                a = e.trim(a.toLowerCase())
            }
            if (-1 != o.options.fx.indexOf(",")) {
                var n = o.options.fx.split(",");
                a = n[Math.floor(Math.random() * n.length)],
                a == i && (a = "fade"),
                a = e.trim(a.toLowerCase())
            }
            if (o.defs.image.data("iviewtransition")) {
                var n = o.defs.image.data("iviewtransition").split(",");
                a = n[Math.floor(Math.random() * n.length)],
                a = e.trim(a.toLowerCase())
            }
            o.defs.easing = o.defs.image.data("ivieweasing") ? o.defs.image.data("ivieweasing") : o.options.easing,
            o.defs.lock = !0,
            o.options.showThumbInControl && o.setNextPrevThumbnail(),
            o.runTransition(a)
        },
        setNextPrevThumbnail: function() {
            var t = this
              , i = next_slide = 0
              , o = next_image = null ;
            i = t.defs.slide - 1,
            i == t.defs.total && (i = 0),
            0 > i && (i = t.defs.total - 1),
            next_slide = t.defs.slide + 1,
            next_slide == t.defs.total && (next_slide = 0),
            next_slide < 0 && (next_slide = t.defs.total - 1),
            o = t.slides.eq(i),
            next_image = t.slides.eq(next_slide);
            var a = o.data(o.data("iviewthumbnail") ? "iviewthumbnail" : "iviewimage")
              , n = next_image.data(next_image.data("iviewthumbnail") ? "iviewthumbnail" : "iviewimage");
            if (a && e(t.options.prevId).length > 0)
                if (t.options.prevNavTemplate) {
                    var s = t.options.prevNavTemplate;
                    s = s.replace("%src%", a),
                    s = s.replace("%alt%", t.options.previousLabel),
                    s = s.replace("%width%", t.options.thumbWidth),
                    s = s.replace("%height%", t.options.thumbHeight),
                    e(t.options.prevId).html(s)
                } else
                    e(t.options.prevId).html('<img src="' + a + '" alt="' + t.options.previousLabel + '" width="' + t.options.thumbWidth + '" height="' + t.options.thumbHeight + '"/>');
            if (n && e(t.options.nextId).length > 0)
                if (t.options.nextNavTemplate) {
                    var r = t.options.nextNavTemplate;
                    r = r.replace("%src%", n),
                    r = r.replace("%alt%", t.options.nextLabel),
                    r = r.replace("%width%", t.options.thumbWidth),
                    r = r.replace("%height%", t.options.thumbHeight),
                    e(t.options.nextId).html(r)
                } else
                    e(t.options.nextId).html('<img src="' + n + '" alt="' + t.options.nextLabel + '" width="' + t.options.thumbWidth + '" height="' + t.options.thumbHeight + '"/>')
        },
        playSlider: function() {
            var e = this;
            null  == e.timer && e.defs.paused && (e.iviewTimer.removeClass("paused").attr("title", e.options.pauseLabel),
            e.setTimer(),
            e.defs.paused = !1,
            e.options.onPlay.call(this))
        },
        stopSlider: function() {
            var e = this;
            e.iviewTimer.addClass("paused").attr("title", e.options.playLabel),
            e.cleanTimer(),
            e.cleanCaptionTimer(),
            e.defs.paused = !0,
            e.options.onPause.call(this)
        },
        setTimerPosition: function() {
            for (var e = this, t = e.options.timerPosition.toLowerCase().split("-"), i = 0; i < t.length; i++)
                "top" == t[i] ? e.iviewTimer.css({
                    top: e.options.timerY + "px",
                    bottom: ""
                }) : "middle" == t[i] ? e.iviewTimer.css({
                    top: e.options.timerY + e.defs.height / 2 - e.options.timerDiameter / 2 + "px",
                    bottom: ""
                }) : "bottom" == t[i] ? e.iviewTimer.css({
                    bottom: e.options.timerY + "px",
                    top: ""
                }) : "left" == t[i] ? e.iviewTimer.css({
                    left: e.options.timerX + "px",
                    right: ""
                }) : "center" == t[i] ? e.iviewTimer.css({
                    left: e.options.timerX + e.defs.width / 2 - e.options.timerDiameter / 2 + "px",
                    right: ""
                }) : "right" == t[i] && e.iviewTimer.css({
                    right: e.options.timerX + "px",
                    left: ""
                })
        },
        disableSelection: function(e) {
            "undefined" != typeof e.onselectstart ? e.onselectstart = function() {
                return !1
            }
             : "undefined" != typeof e.style.MozUserSelect ? e.style.MozUserSelect = "none" : "undefined" != typeof e.style.webkitUserSelect ? e.style.webkitUserSelect = "none" : "undefined" != typeof e.style.userSelect ? e.style.userSelect = "none" : e.onmousedown = function() {
                return !1
            }
            ,
            e.unselectable = "on"
        },
        isTouch: function() {
            return !!("ontouchstart" in t)
        }
    };
    var r = function(e, t, i) {
        this.m_pfnPercent = t,
        this.m_pfnFinished = i,
        this.m_nLoaded = 0,
        this.m_nProcessed = 0,
        this.m_aImages = new Array,
        this.m_nICount = e.length;
        for (var o = 0; o < e.length; o++)
            this.Preload(e[o])
    }
    ;
    r.prototype = {
        Preload: function(e) {
            var t = new Image;
            this.m_aImages.push(t),
            t.onload = r.prototype.OnLoad,
            t.onerror = r.prototype.OnError,
            t.onabort = r.prototype.OnAbort,
            t.oImagePreload = this,
            t.bLoaded = !1,
            t.source = e,
            t.src = e
        },
        OnComplete: function() {
            this.m_nProcessed++,
            this.m_nProcessed == this.m_nICount ? this.m_pfnFinished() : this.m_pfnPercent(Math.round(this.m_nProcessed / this.m_nICount * 10))
        },
        OnLoad: function() {
            this.bLoaded = !0,
            this.oImagePreload.m_nLoaded++,
            this.oImagePreload.OnComplete()
        },
        OnError: function() {
            this.bError = !0,
            this.oImagePreload.OnComplete()
        },
        OnAbort: function() {
            this.bAbort = !0,
            this.oImagePreload.OnComplete()
        }
    },
    e.fn.iView = function(t) {
        t = jQuery.extend({
            fx: "random",
            easing: "easeOutQuad",
            strips: 20,
            blockCols: 10,
            blockRows: 5,
            animationSpeed: 500,
            pauseTime: 5e3,
            startSlide: 0,
            directionNav: !0,
            directionNavHoverOpacity: .6,
            controlNav: !1,
            controlNavNextPrev: !0,
            controlNavHoverOpacity: .6,
            controlNavThumbs: !1,
            controlNavTooltip: !0,
            captionSpeed: 500,
            captionEasing: "easeInOutSine",
            captionOpacity: 1,
            autoAdvance: !0,
            keyboardNav: !0,
            touchNav: !0,
            pauseOnHover: !1,
            nextLabel: "Next",
            previousLabel: "Previous",
            playLabel: "Play",
            pauseLabel: "Pause",
            closeLabel: "Close",
            randomStart: !1,
            timer: "Pie",
            timerBg: "#000",
            timerColor: "#EEE",
            timerOpacity: .5,
            timerDiameter: 30,
            timerPadding: 4,
            timerStroke: 3,
            timerBarStroke: 1,
            timerBarStrokeColor: "#EEE",
            timerBarStrokeStyle: "solid",
            timerPosition: "top-right",
            timerX: 10,
            timerY: 10,
            tooltipX: 5,
            tooltipY: -5,
            onBeforeChange: function() {},
            onAfterChange: function() {},
            onAfterLoad: function() {},
            onLastSlide: function() {},
            onSlideShowEnd: function() {},
            onPause: function() {},
            onPlay: function() {}
        }, t),
        e(this).each(function() {
            var i = e(this);
            new s(i,t)
        }
        )
    }
    ,
    e.fn.reverse = "undefined" == typeof []._reverse ? Array.prototype.reverse : Array.prototype._reverse;
    var d, p = e([]), c = e.resize = e.extend(e.resize, {}), l = "setTimeout", m = "resize", f = m + "-special-event", h = "delay", u = "throttleWindow";
    c[h] = 250,
    c[u] = !0,
    e.event.special[m] = {
        setup: function() {
            if (!c[u] && this[l])
                return !1;
            var t = e(this);
            p = p.add(t),
            e.data(this, f, {
                w: t.width(),
                h: t.height()
            }),
            1 === p.length && n()
        },
        teardown: function() {
            if (!c[u] && this[l])
                return !1;
            var t = e(this);
            p = p.not(t),
            t.removeData(f),
            p.length || clearTimeout(d)
        },
        add: function(t) {
            function o(t, o, n) {
                var s = e(this)
                  , r = e.data(this, f);
                "undefined" != typeof r && (r.w = o !== i ? o : s.width(),
                r.h = n !== i ? n : s.height()),
                a.apply(this, arguments)
            }
            if (!c[u] && this[l])
                return !1;
            var a;
            return e.isFunction(t) ? (a = t,
            o) : (a = t.handler,
            void (t.handler = o))
        }
    };
    var g = !!("ontouchstart" in t)
      , v = g ? "touchstart" : "mousedown"
      , w = g ? "touchend" : "mouseup"
      , b = g ? "touchmove" : "mousemove";
    e.event.special.swipe = {
        scrollSupressionThreshold: 10,
        durationThreshold: 1e3,
        horizontalDistanceThreshold: 30,
        verticalDistanceThreshold: 75,
        setup: function() {
            var t = this
              , o = e(t);
            o.bind(v, function(t) {
                function a(t) {
                    if (r) {
                        var i = t.originalEvent.touches ? t.originalEvent.touches[0] : t;
                        n = {
                            time: (new Date).getTime(),
                            coords: [i.pageX, i.pageY]
                        },
                        Math.abs(r.coords[0] - n.coords[0]) > e.event.special.swipe.scrollSupressionThreshold && t.preventDefault()
                    }
                }
                var n, s = t.originalEvent.touches ? t.originalEvent.touches[0] : t, r = {
                    time: (new Date).getTime(),
                    coords: [s.pageX, s.pageY],
                    origin: e(t.target)
                };
                o.bind(b, a).one(w, function() {
                    o.unbind(b, a),
                    r && n && n.time - r.time < e.event.special.swipe.durationThreshold && Math.abs(r.coords[0] - n.coords[0]) > e.event.special.swipe.horizontalDistanceThreshold && Math.abs(r.coords[1] - n.coords[1]) < e.event.special.swipe.verticalDistanceThreshold && r.origin.trigger("swipe").trigger(r.coords[0] > n.coords[0] ? "swipeleft" : "swiperight"),
                    r = n = i
                }
                )
            }
            )
        }
    },
    e.each({
        swipeleft: "swipe",
        swiperight: "swipe"
    }, function(t, i) {
        e.event.special[t] = {
            setup: function() {
                e(this).bind(i, e.noop)
            }
        }
    }
    ),
    e.fn.tipr = function(t) {
        var i = e.extend({
            callback: "",
            style: "light",
            speed: 200,
            mode: "bottom"
        }, t);
        return this.each(function() {
            var t = ".tipr_container_" + i.mode;
            e(this).hover(function() {
                var o = e(this).attr("data-tip")
                  , a = e(this).attr("data-tipelement");
                a && e(this).parent().find(a).length > 0 && (o = e(this).parent().find(a).html(),
                i.callback && "function" == typeof i.callback && i.callback(this, e(this).parent().find(a).first()));
                var n = '<div class="tipr_container_' + i.mode + '"><div class="tipr_point_' + i.mode + "_" + i.style + '"><div class="tipr_content_' + i.style + '">' + o + "</div></div></div>";
                e(this).append(n);
                var s = e(t).outerWidth()
                  , r = e(this).width()
                  , d = r / 2 - s / 2;
                e(this).parent().parent().parent().length > 0 && e(this).parent().parent().parent().css("z-index", 10),
                e(t).css("margin-left", d + "px"),
                e(this).removeAttr("title"),
                e(t).fadeIn(i.speed)
            }
            , function() {
                e(this).parent().parent().parent().length > 0 && e(this).parent().parent().parent().css("z-index", "auto"),
                e(t).remove()
            }
            )
        }
        )
    }
    ,
    e(document).ready(function() {
        e(".hotspot").tipr({
            callback: function(t, i) {
                if (e(i).find(".hotspot-url").length > 0) {
                    var o = e(i).find(".hotspot-url").attr("data-url");
                    e(t).attr("href", o)
                }
            }
        })
    }
    )
}
(jQuery, this);
